import React from 'react';
import PT from 'prop-types';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import SVG from 'react-inlinesvg';
import moreIcon from '@lifesize/ux-assets/vectors/svgIcons/more.svg';
import Dropdown from 'components/Dropdown/Dropdown';
import _map from 'lodash/map';
import lsConfig from 'utils/global-config';
import classes from './UserMoreMenu.module.scss';

const messages = defineMessages({
  available: { id: 'availabilityDropdown.available.label', defaultMessage: 'Available' },
  DND: { id: 'availabilityDropdown.DND.label', defaultMessage: 'Do Not Disturb' },
  logout: { id: 'availabilityDropdown.logout.label', defaultMessage: 'Sign Out' },
});

export class UserMoreMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.AVAILABILITY_LABELS = [
      {
        label: this.props.intl.formatMessage(messages.available),
        circleClass: classes.available,
        action: this.onAvailable,
        dataTestId: 'availableLink'
      },
      {
        label: this.props.intl.formatMessage(messages.DND),
        circleClass: classes.dnd,
        action: this.onDoNotDisturb,
        dataTestId: 'dndLink'
      },
      {
        label: this.props.intl.formatMessage(messages.logout),
        circleClass: classes.logout,
        action: this.onLogout,
        dataTestId: 'logoutLink'
      }
    ];
  }

  onAvailable = (event) => {
    event.preventDefault();
    this.props.toggleDoNotDisturb(false);
  }

  onDoNotDisturb = (event) => {
    event.preventDefault();
    this.props.toggleDoNotDisturb(true);
  }

  onLogout = (event) => {
    event.preventDefault();
    lsConfig.skipOnBeforeUnload();
    this.props.logout();
  }

  buttonComponent = () => (
    <div className={classes.moreButton} data-testid="btnUserAvailabilityDropdown">
      <SVG src={moreIcon} data-testid="moreIcon" />
    </div>
  );

  menuComponent = () =>
    (
      <ul>
        <li>
          <a tabIndex={-2} onClick={this.props.handleClickSettings} data-testid="settingsLink">
            <FormattedMessage
              id="availabilityDropdown.settings.label"
              defaultMessage="Settings"
            />
          </a>
        </li>
        {this.props.showAdminConsole &&
          <li>
            <a tabIndex={-1} onClick={() => this.props.handleAdminConsoleClick()} data-testid="adminLink">
              <FormattedMessage
                id="availabilityDropdown.adminconsole.label"
                defaultMessage="Admin Console"
              />
            </a>
          </li>
        }
        <li>
          <a tabIndex={-1} onClick={this.props.handleClickMyProfile} data-testid="profileLink">
            <FormattedMessage
              id="availabilityDropdown.profile.label"
              defaultMessage="My Profile"
            />
          </a>
        </li>
        <hr />
        {
          _map(this.AVAILABILITY_LABELS, (labelObject, index) =>
            (
              <li key={labelObject.label}>
                <a tabIndex={index} onClick={labelObject.action} data-testid={labelObject.dataTestId}>
                  <div className={`${classes.availCircle} ${labelObject.circleClass}`} />
                  <span className={classes.availLabel}>
                    {labelObject.label}
                  </span>
                </a>
              </li>
            )
          )
        }
      </ul>
    );

  render() {
    return (
      <div className={classes.container} data-testid="menuUserAvailabilityDropdown">
        <Dropdown
          buttonComponent={this.buttonComponent()}
          menuComponent={this.menuComponent()}
        />
      </div>
    );
  }
}

UserMoreMenu.propTypes = {
  handleAdminConsoleClick: PT.func.isRequired,
  handleClickMyProfile: PT.func.isRequired,
  handleClickSettings: PT.func.isRequired,
  intl: PT.object.isRequired,
  logout: PT.func.isRequired,
  showAdminConsole: PT.bool.isRequired,
  toggleDoNotDisturb: PT.func.isRequired
};

export default injectIntl(UserMoreMenu);
